interface LogoProps {
  width: string
  height: string
  color?: string
}

export function Logo({ width, height, color }: LogoProps) {
  return (
    <svg
      id='Component_1_2'
      data-name='Component 1 – 2'
      xmlns='http://www.w3.org/2000/svg'
      width={width} //'123.981'
      height={height} //'40.283'
      viewBox='0 0 123.981 40.283'
    >
      <path
        id='Path_3322'
        data-name='Path 3322'
        d='M15.525-153.549h4.081v-6.879l5.48,6.879h5.3l-7.17-8.044,7.112-8.1h-5.3l-5.421,6.849v-12.271H15.525Zm17.022,0h4.081V-169.7H32.547Zm2.069-18.071a2.41,2.41,0,0,0,2.507-2.39,2.41,2.41,0,0,0-2.507-2.39,2.393,2.393,0,0,0-2.507,2.39A2.393,2.393,0,0,0,34.616-171.62ZM52.6-158.154c-.117-5.917-9.065-4.081-9.065-7.024,0-.933.787-1.545,2.3-1.545,1.6,0,2.594.845,2.711,2.1h3.906c-.233-3.206-2.594-5.334-6.5-5.334-3.993,0-6.383,2.157-6.383,4.838,0,5.917,9.123,4.081,9.123,6.966,0,.933-.874,1.661-2.477,1.661A2.68,2.68,0,0,1,43.3-158.65h-4.11c.175,3,3,5.363,7.053,5.363C50.18-153.287,52.6-155.385,52.6-158.154Zm3.41-.408c0,3.7,2.069,5.013,5.159,5.013h2.565v-3.439H61.839c-1.282,0-1.72-.466-1.72-1.545v-7.811h3.614V-169.7H60.119v-3.993H56.01v3.993H54.086v3.352H56.01Zm10.668,5.013h4.081V-169.7H66.677Zm2.069-18.071a2.41,2.41,0,0,0,2.507-2.39,2.41,2.41,0,0,0-2.507-2.39,2.393,2.393,0,0,0-2.507,2.39A2.393,2.393,0,0,0,68.747-171.62Zm6.033,18.071H78.86v-21.568H74.78Zm8.1,0h4.081v-21.568H82.883Z'
        transform='translate(37.018 188.646)'
        fill={color}
      />
      <path
        id='Path_4'
        data-name='Path 4'
        d='M24.641,93.34h4.713c5.677,0,9.48-2.41,9.48-9.212V71.359H31.282V84.182c0,1.982-.8,2.838-3.16,2.838H11c-2.356,0-3.16-.857-3.16-2.838V71.359H.287V84.128c0,6.8,3.8,9.212,9.48,9.212H14.48'
        transform='translate(1.315 -53.058)'
        fill={color}
      />
      <path
        id='Path_6'
        data-name='Path 6'
        d='M24.106,6.159h14.44V0H0V6.159H7.686'
        transform='matrix(0.966, -0.259, 0.259, 0.966, 0, 9.977)'
        fill={color}
      />
    </svg>
  )
}
